import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { HsnCodes } from "../hsn-codes/hsn-codes.entity";
import { Item } from "../items/item.entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { FgpriceList } from "../fg-pricelist/fg-pricelist-entity";

@Entity('products')
export class Product {

  @PrimaryGeneratedColumn("increment",{name:'product_id'})
  productId?:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"code"
      })
      productCode:string;

    @Column("varchar",{
      nullable:false,
      length:30,
      name:"name"
      })
      productName:string;

      
    @Column("varchar",{
      nullable:false,
      length:30,
      name:"hsn_code"
      })
      hsnCode:number;
      


    @Column("varchar",{
      nullable:true,
      length:50,
      name:"remarks"
      })
    remarks:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type=>Item, item=>item.productInfo)
  itemInfo:Item[];
  @OneToMany(type=>Product, product=>product.productId,{cascade: true})
  productInfo:HsnCodes[];
  // @OneToMany(type => FgpriceList, info => info.productId, { cascade: true })
  // fgPriceInfo: FgpriceList[];
  
}
